import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { OpportunityBoardType } from '@fitness-force/enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'stage-name',
  template: `
    <ng-container
      *ngIf="{
        row: columnData() | async,
      } as $"
    >
      <span *ngIf="$.row && $.row.opp_board_type"
        >{{ getStageName($.row.opp_board_type) }}
      </span>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class StageNameComponent {
  readonly additionData = input(new BehaviorSubject(null));
  readonly columnData = input(new BehaviorSubject(null));
  type!: any;

  getStageName(value: any) {
    if (typeof value === 'number' || !isNaN(Number(value))) {
      return OpportunityBoardType[Number(value)];
    }
    return value;
  }
}
